var doWorld = {
    init : function() {
        setTimeout(function() {
            world.moveToNextWaypoint(1000);
        })
    },
    update : function(delta) {
        
    },
    shutDown : function() {
        
    }
}
